export default __webpack_public_path__ + "static/media/rulebookapp.6c02dfff.png";